export default __webpack_public_path__ + "static/media/cultura.2e143899.png";